// import {useTitle} from "@/Utilities/Hooks";
import AppLayout from "@/Layouts/AppLayout";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import {Inertia} from "@inertiajs/inertia";
import React from "react";
import TagForm from "@/Components/TagForm";
import LayoutIcon from "@/Components/LayoutIcon";
import {Tag as TagsIcon} from "@/Icons";

export default function Edit({ tag, budget_tags }) {
  return (
    <>
      <div className="my-3">
        <TagForm tag={tag.data} budget_tags={budget_tags.data} />
      </div>
    </>
  )
}

Edit.layout = page => {
  const tag = page.props.tag.data;
  const title = tag.is_global ? 'Category' : 'Edit category';

  return (
    <AppLayout title={title}>
      <OrganizationLayout
        header={title}
        backAction={{ label: 'Back', callback: () => Inertia.visit('/categories') }}
        preamble={tag ? `${tag.name}` : null}
        icon={<LayoutIcon><TagsIcon size={40} className="text-black"/></LayoutIcon>}
      >
        {page}
      </OrganizationLayout>
    </AppLayout>
  )
}
